import React, { useEffect } from "react";

// style
import { BackdropWrapper } from '../../assets/styles/components/modal';

const Backdrop = ({ onClose }) => {
    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            // 스크롤 방지 해제
            document.body.style.overflow = "unset";
        };
    }, []);

    return (
        <BackdropWrapper className="Backdrop" onClick={onClose} />
    );
};

export default Backdrop;
